// src/pages/admin/dashboard/tabs/transactions/CreditDebit.jsx

import React from "react";
import CreditDebitAmount from "../../../../../components/transactions/CreditDebitAmount";
import { adminApi } from "../../../../../services/index";

const CreditDebit = () => {
  return (
    <CreditDebitAmount
      getUser={adminApi.getUserByAccountNumber}
      updateAmount={adminApi.updateAmount}
    />
  );
};

export default CreditDebit;
